import * as types from "./types";
import { selectors as brandSelectors } from "../brand";
import {
  selectors as bridgeSelectors,
  actions as bridgeActions
} from "../bridge";
import {
  selectors as routerSelectors,
  actions as routerActions
} from "../router";
import { sendNativeMessage } from "../../ui/utils/native";

const bookLaunched = (isbn, { context, ...options }) => ({
  type: types.BOOK_LAUNCHED,
  isbn,
  options,
  context
});

const launchBook = (isbn, options = {}, state, dispatch) => {
  const isNative = routerSelectors.isNative(state);
  const platform = routerSelectors.getQueryParam(state, "platform");
  const protocol = brandSelectors.getBrandValue(
    state,
    "ReadOffline.protocol",
    "vbk://"
  );
  const { location, search } = options;

  if (isNative) {
    var locationString;
    if (!location) {
      locationString = protocol + isbn;
    } else if (location.cfi) {
      // cfi is null for pdf results
      locationString = protocol + isbn + "/epubcfi" + location.cfi;
    } else if (location.result_id) {
      locationString = protocol + isbn + "/pageid/" + location.result_id;
    }

    // Add the search query to the location
    if (search) {
      locationString += `?q=${search}`;
    }
    sendNativeMessage(platform, "open:book", {
      isbn,
      location: locationString,
      search
    });
  } else {
    const options = {};
    if (search) {
      options.q = search;
    }
    if (location && location.cfi) {
      window.location.assign(
        routerActions.buildUrl(
          state,
          `books/${isbn}/cfi${location.cfi}`,
          options
        )
      );
    } else if (location && location.result_id) {
      window.location.assign(
        routerActions.buildUrl(
          state,
          `books/${isbn}/pageid/${location.result_id}`,
          options
        )
      );
    } else {
      window.location.assign(
        routerActions.buildUrl(state, `books/${isbn}/recent`, options)
      );
    }
  }
  // Wait for the route change to be fully processed
  window.setTimeout(() => dispatch(bookLaunched(isbn, options)), 0);
};

export const launchLicensedBook = (isbn, options = {}) => async (
  dispatch,
  getState
) => {
  const state = getState();
  launchBook(isbn, options, state, dispatch);
};

export const launchBridgeBook = (isbn, options = {}) => async (
  dispatch,
  getState
) => {
  const state = getState();
  dispatch(bridgeActions.activateAsset(isbn))
    .then(() => launchBook(isbn, options, state, dispatch))
    .catch(() => {
      // This is handled by the activation error
    });
};
